module.exports = __webpack_public_path__ + "static/img/KPLN.d8ecc1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KPLN.png
// module id = 34oe
// module chunks = 1